var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 15 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M10.666 6.68424L8.16146 7.82096C7.90128 7.93943 7.61858 8.00063 7.33268 8.00065C7.08218 8.00065 6.83414 7.95331 6.60156 7.86198L6.5026 7.82031L3.99935 6.67839V8C3.99935 8.15004 4.13456 8.4846 4.80208 8.81836C5.43843 9.13653 6.34863 9.33333 7.33268 9.33333C8.31654 9.33331 9.22633 9.13644 9.86263 8.81836C10.5302 8.48459 10.666 8.15004 10.666 8V6.68424ZM13.3327 8V5.47396L11.9993 6.07878V8C11.9993 8.91082 11.2917 9.59404 10.459 10.0104C9.59508 10.4424 8.47031 10.6666 7.33268 10.6667C6.195 10.6667 5.06967 10.4424 4.20573 10.0104C3.37309 9.59403 2.66602 8.91073 2.66602 8V6.07031L0.789063 5.21484V5.21419C0.55587 5.10987 0.357333 4.94115 0.217448 4.72721C0.0756483 4.51031 0 4.25654 0 3.9974C3.41386e-05 3.73836 0.0757248 3.48506 0.217448 3.26823C0.35752 3.05397 0.556087 2.88425 0.789714 2.77995L6.5026 0.18099V0.180339C6.76315 0.0615032 7.04631 0 7.33268 0C7.61902 1.92949e-05 7.90224 0.0615057 8.16276 0.180339L8.16211 0.18099L13.8763 2.78255L13.8757 2.7832C14.108 2.88443 14.3074 3.04935 14.4492 3.25977C14.5949 3.47597 14.6737 3.73019 14.6764 3.99089C14.6771 4.05175 14.6736 4.1126 14.666 4.17253V8C14.666 8.36814 14.3675 8.66658 13.9993 8.66667C13.6312 8.66667 13.3327 8.36819 13.3327 8ZM1.34245 4.00195L7.05599 6.60677C7.14285 6.64639 7.23722 6.66732 7.33268 6.66732C7.4281 6.6673 7.52256 6.64637 7.60938 6.60677H7.61068L13.3327 4.00977V4C13.3297 3.99868 13.3266 3.99746 13.3236 3.99609L7.60938 1.39388V1.39323C7.52256 1.35363 7.4281 1.33335 7.33268 1.33333C7.23728 1.33333 7.1428 1.35366 7.05599 1.39323L7.05534 1.39388L1.3418 3.99349L1.33333 3.9974L1.34245 4.00195Z",
          fill: _vm.fill,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }